import React from 'react'
import styled from 'styled-components'

const Row = styled.tr`
  td {
    padding: ${({ theme }) =>
      `${theme.spacing.xsmall} ${theme.spacing.medium} ${theme.spacing.small} ${theme.spacing.medium}`};
    border-bottom: none;
  }
`

const Wrap = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
  flex-wrap: wrap;
`

const Label = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
`

const Chip = styled.button`
  border: 1px dashed ${({ theme }) => theme.colors.border.default};
  background: ${({ theme }) => theme.colors.background.primary};
  color: ${({ theme }) => theme.colors.text.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.round};
  padding: ${({ theme }) => `${theme.spacing.xsmall} ${theme.spacing.medium}`};
  font-family: inherit;
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  cursor: pointer;
  transition: all ${({ theme }) => theme.transitions.fast};

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.primary};
  }
`

export interface AddMetricRowProps {
  label: string
  options: { key: string; label: string }[]
  onAdd: (key: string) => void
}

/**
 * Edit-mode row listing the section's empty metrics as dashed chips —
 * clicking one shows its row (instead of rendering walls of empty inputs).
 */
export const AddMetricRow: React.FC<AddMetricRowProps> = ({
  label,
  options,
  onAdd,
}) => (
  <Row>
    <td colSpan={4}>
      <Wrap>
        <Label>+ {label}</Label>
        {options.map((option) => (
          <Chip
            key={option.key}
            type="button"
            onClick={() => onAdd(option.key)}
          >
            {option.label}
          </Chip>
        ))}
      </Wrap>
    </td>
  </Row>
)
